import { forwardRef, HTMLAttributes } from "react";

import Link from "@/components/Link";
import { ExternalLinks } from "@/constants/links";
import { isSet } from "@/utils/helpers";

export function TOS() {
  return (
    <Link href={ExternalLinks.TERMS} target="_blank">
      Terms of Service
    </Link>
  );
}

export function PrivacyPolicy() {
  return (
    <Link href={ExternalLinks.PRIVACY_POLICY} target="_blank">
      Privacy Policy
    </Link>
  );
}

type MarketingConsentProps = {
  hidePrivacyPolicy?: boolean;
} & HTMLAttributes<HTMLParagraphElement>;

export const MarketingConsent = forwardRef<
  HTMLParagraphElement,
  MarketingConsentProps
>((props, ref) => {
  const hidePrivacyPolicy =
    isSet(props.hidePrivacyPolicy) && props.hidePrivacyPolicy;

  if (hidePrivacyPolicy) {
    return (
      <p ref={ref} {...props}>
        By entering your information and clicking submit, you agree to Restore’s{" "}
        <TOS />, and consent to receive marketing and appointment communications
        via email and text from Restore.
      </p>
    );
  }

  return (
    <p ref={ref} {...props}>
      By entering your information and clicking submit, you agree to Restore’s{" "}
      <TOS /> and <PrivacyPolicy />, and consent to receive marketing and
      appointment communications via email and text from Restore.
    </p>
  );
});

export const CardShell = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="mb-3 flex w-full flex-col rounded-[10px] border border-neutral-lightest bg-white shadow-[0_4px_4px_0_rgba(174,174,174,0.25)] last:mb-0">
      {children}
    </div>
  );
};
